const init = () => {
	flatpickr.localize(flatpickr.l10ns.de);

	$('.input-group.datepicker').each(function(){
		let container = $(this);
		let input = $(this).find('input');

		if(!input.hasClass('flatpickr-input')){			
			let options = {
			    allowInput: true,
				clickOpens: false,
				dateFormat: 'd.m.Y',
				wrap: true,
				disableMobile: true
			};

			if(container.data('time')){
				options = {
					...options,
				  	enableTime: true,
				  	dateFormat: 'd.m.Y H:i'
				}
			}
			
			if(container.data('max-date')){
				options = {
					...options,
					maxDate: container.data('max-date')
				}
			}

			if(container.data('min-date')){
				options = {
					...options,
					minDate: container.data('min-date')
				}
			}

			let datepicker = flatpickr(container, options);
		}
	});
}

export default init;